<form nz-form [formGroup]="form" (ngSubmit)="onFormSubmit()">
	<app-text-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.ssoLessonId]"
		[controlName]="LessonCsvKeys.ssoLessonId"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.ssoLessonId]"
		[required]="form.get(LessonCsvKeys.ssoLessonId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.ssoUnitId]"
		[controlName]="LessonCsvKeys.ssoUnitId"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.ssoUnitId]"
		[required]="form.get(LessonCsvKeys.ssoUnitId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-language-dropdown-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.defaultLangId]"
		[controlName]="LessonCsvKeys.defaultLangId"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.defaultLangId]"
		[required]="form.get(LessonCsvKeys.defaultLangId)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-integer-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.displayOrder]"
		[controlName]="LessonCsvKeys.displayOrder"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.displayOrder]"
		[required]="form.get(LessonCsvKeys.displayOrder)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.enName]"
		[controlName]="LessonCsvKeys.enName"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.enName]"
		[required]="form.get(LessonCsvKeys.enName)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.enImageUri]"
		[controlName]="LessonCsvKeys.enImageUri"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.enImageUri]"
		[required]="form.get(LessonCsvKeys.enImageUri)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-text-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.enDescriptionShort]"
		[controlName]="LessonCsvKeys.enDescriptionShort"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.enDescriptionShort]"
		[required]="form.get(LessonCsvKeys.enDescriptionShort)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-textarea-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.enDescriptionHtml]"
		[controlName]="LessonCsvKeys.enDescriptionHtml"
		[placeholder]="LESSON_CSV_LABELS[LessonCsvKeys.enDescriptionHtml]"
		[required]="form.get(LessonCsvKeys.enDescriptionHtml)?.hasValidator(Validators.required) ? true : false"
		[formGroup]="form"
	/>

	<app-checkbox-field
		[label]="LESSON_CSV_LABELS[LessonCsvKeys.active]"
		[controlName]="LessonCsvKeys.active"
		[formGroup]="form"
	/>

	<nz-form-item>
		<nz-form-control [nzOffset]="7" [nzSpan]="12">
			<div class="buttons">
				<button nz-button nzType="primary" [disabled]="loading() || form.invalid">
					Submit
					@if (loading()) {
						<nz-spin nzSimple nzSize="small"></nz-spin>
					}
				</button>
				<button nz-button (click)="onClearClicked()">Clear</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>
